import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout, Section, ReqTable } from "./LegalLayout";

const Privacy = () => (
  <LegalLayout title="Политика конфиденциальности" updated="14 июня 2026 г.">
    <Section title="1. Оператор персональных данных">
      <p>
        Оператором персональных данных является индивидуальный предприниматель
        КОКОВ АЛЕКСАНДР ДМИТРИЕВИЧ, ОГРНИП: 325784700333162, ИНН:
        784302022304, адрес: Россия, г. Санкт-Петербург, пос. Комарово,
        Цветочная 2А (далее — «Оператор», «мы»).
      </p>
      <p>
        Настоящая Политика разработана в соответствии с Федеральным законом от
        27.07.2006 № 152-ФЗ «О персональных данных» и действует в отношении
        сайта <strong>swingmentor.pro</strong>.
      </p>
    </Section>

    <Section title="2. Какие данные мы обрабатываем">
      <ul>
        <li>
          <strong>Данные аккаунта:</strong> имя, фамилия, адрес электронной
          почты, хеш пароля, гольф-гандикап.
        </li>
        <li>
          <strong>Пользовательский контент:</strong> исходные и обработанные
          видеозаписи гольф-свинга, изображения отдельных фаз свинга, текстовые
          рекомендации, оценки и структурированные результаты анализа.
        </li>
        <li>
          <strong>Платёжные данные:</strong> сведения о факте и сумме оплаты,
          идентификатор платежа. Данные банковской карты обрабатываются
          исключительно платёжным сервисом ЮKassa и Оператору не передаются.
          При криптооплате через Trybit Оператор получает и хранит только факт
          оплаты, сумму, валюту, идентификатор заказа и статус платежа.
        </li>
        <li>
          <strong>Технические данные:</strong> cookie-файлы, необходимые для
          авторизации и работы сервиса.
        </li>
      </ul>
      <p>
        Специальные категории данных (здоровье, биометрия и т.п.) нами
        целенаправленно не обрабатываются.
      </p>
    </Section>

    <Section title="3. Цели и правовые основания обработки">
      <ReqTable
        rows={[
          ["Регистрация и доступ к сервису", "Исполнение договора (п. 5 ч. 1 ст. 6 152-ФЗ)"],
          ["Анализ видеозаписей свинга и выдача рекомендаций", "Исполнение договора; согласие субъекта"],
          ["Обработка платежей через ЮKassa или Trybit, направление чеков при необходимости", "Исполнение договора; 54-ФЗ"],
          ["Поддержка пользователей по e-mail", "Исполнение договора"],
          ["Соблюдение требований законодательства РФ", "П. 6 ч. 1 ст. 6 152-ФЗ"],
        ]}
      />
    </Section>

    <Section title="4. Локализация и передача данных">
      <p>
        Место хранения персональных данных определяется регионом пользователя,
        установленным при регистрации:
      </p>
      <p>
        <strong>Пользователи из Российской Федерации.</strong> Сбор, запись,
        систематизация, накопление, хранение, уточнение и извлечение
        персональных данных граждан Российской Федерации осуществляются с
        использованием баз данных, расположенных на территории Российской
        Федерации (г. Санкт-Петербург), в соответствии с требованиями ст. 18
        Федерального закона № 152-ФЗ.
      </p>
      <p>
        <strong>Пользователи из других стран (ЕС, Азия и иные регионы).</strong>{" "}
        Данные аккаунта, история анализов и медиафайлы таких пользователей
        хранятся на сервере, расположенном в Федеративной Республике Германия
        (ЕС). Обработка осуществляется в соответствии с Регламентом ЕС 2016/679
        (GDPR). Данные пользователей из ЕС не передаются и не копируются на
        серверы, расположенные за пределами ЕС, за исключением случаев,
        предусмотренных настоящей Политикой.
      </p>
      <p>
        <strong>Анализ видеозаписей.</strong> Для выполнения автоматизированного
        анализа временная копия видеозаписи вместе с техническим
        идентификатором задания может передаваться поставщику
        ИИ-инфраструктуры. Имя, адрес электронной почты, платёжные сведения и
        иные данные аккаунта такому узлу не передаются. Временная копия
        удаляется после завершения обработки.
      </p>
      <p>Третьи лица:</p>
      <ul>
        <li>
          <strong>ЮKassa (ООО НКО «ЮМани»)</strong> — обработка платежей для
          пользователей из РФ в соответствии со стандартом PCI DSS.
        </li>
        <li>
          <strong>Trybit</strong> — обработка международных криптоплатежей.
          Оператору передаются только технические сведения о платеже,
          необходимые для начисления тарифа.
        </li>
        <li>
          <strong>Поставщики ИИ-инфраструктуры</strong> — автоматизированная
          обработка видеозаписей без привязки к данным аккаунта.
        </li>
      </ul>
      <p>
        Персональные данные не продаются и не передаются третьим лицам в
        рекламных или коммерческих целях.
      </p>
    </Section>

    <Section title="5. Сроки хранения">
      <ul>
        <li>
          Данные аккаунта — пока существует аккаунт пользователя либо пока их
          хранение необходимо для исполнения договора и требований закона.
        </li>
        <li>
          Исходная видеозапись и промежуточные файлы — в течение выполнения
          анализа и предусмотренных повторных попыток. После успешного
          завершения задания либо его окончательного завершения с ошибкой они
          удаляются автоматически.
        </li>
        <li>
          Временная копия видеозаписи на отдельном вычислительном узле — до
          завершения соответствующей попытки обработки, после чего удаляется.
        </li>
        <li>
          Обработанное видео — пока включена настройка сохранения видео и
          существует аккаунт. При отключении настройки ранее сохранённые
          обработанные видео удаляются.
        </li>
        <li>
          Текст анализа, оценки, рекомендации, изображения фаз и история
          тренировок — пока существует аккаунт либо до исполнения
          подтверждённого запроса пользователя на удаление.
        </li>
        <li>
          Данные платёжных операций — 5 лет согласно требованиям
          бухгалтерского учёта (402-ФЗ).
        </li>
      </ul>
      <p>
        При удалении аккаунта сведения профиля, история анализов и связанные с
        ними медиафайлы удаляются. По отдельному подтверждённому запросу данные
        удаляются в срок до 30 дней, кроме сведений, которые Оператор обязан
        хранить в силу закона.
      </p>
    </Section>

    <Section title="6. Права субъектов персональных данных">
      <p>Вы вправе:</p>
      <ul>
        <li>получить подтверждение факта обработки и копию своих данных;</li>
        <li>потребовать исправления неточных данных;</li>
        <li>потребовать удаления данных («право на забвение»);</li>
        <li>
          отозвать данное ранее{" "}
          <Link to="/legal/consent">согласие на обработку</Link>;
        </li>
        <li>
          обратиться с жалобой в Роскомнадзор:{" "}
          <a href="https://rkn.gov.ru" target="_blank" rel="noopener noreferrer">
            rkn.gov.ru
          </a>.
        </li>
      </ul>
      <p>
        Для реализации прав направьте запрос на{" "}
        <a href="mailto:info@swingmentor.pro">info@swingmentor.pro</a> с темой
        «Персональные данные». Ответим в течение 10 рабочих дней.
      </p>
    </Section>

    <Section title="6а. Дополнительные права пользователей из ЕС (GDPR)">
      <p>
        Если вы находитесь на территории Европейского Союза, в дополнение к
        правам, указанным в разделе 6, вы имеете право:
      </p>
      <ul>
        <li>на переносимость данных (получение данных в машиночитаемом формате);</li>
        <li>на ограничение обработки;</li>
        <li>
          подать жалобу в надзорный орган по защите данных в вашей стране.
        </li>
      </ul>
      <p>
        Правовые основания обработки данных пользователей из ЕС: исполнение
        договора (ст.&nbsp;6(1)(b) GDPR), согласие субъекта
        (ст.&nbsp;6(1)(a) GDPR), законные интересы Оператора
        (ст.&nbsp;6(1)(f) GDPR).
      </p>
    </Section>

    <Section title="7. Защита данных">
      <p>
        Оператор принимает необходимые правовые, организационные и технические
        меры защиты: передача данных по HTTPS, хранение паролей в
        виде стойких криптографических хешей, ограничение доступа к данным,
        резервное копирование.
      </p>
    </Section>

    <Section title="8. Cookies">
      <p>
        Сайт использует технические cookie-файлы, необходимые для работы
        (авторизация, сохранение настроек языка и валюты). Маркетинговые
        cookie-файлы и пиксели отслеживания не используются.
      </p>
    </Section>

    <Section title="9. Контакты">
      <p>
        По вопросам обработки персональных данных:{" "}
        <a href="mailto:info@swingmentor.pro">info@swingmentor.pro</a>, тел.
        +7 999 032-27-57.
      </p>
    </Section>
  </LegalLayout>
);

export default Privacy;
